import { LocaleMessageObject } from "vue-i18n";

export default {
  api: {
    notFound:
      "Unsere Server sind zur Zeit nicht verfügbar. Versuche es später noch einmal.",
    forbidden: "Bitte logge dich ein, um diese Seite zu sehen.",
    serverError:
      "Auf unseren Servern ist ein Fehler aufgetreten. Versuche es später noch einmal.",
    wrongFormat: "Das Format ist ungültig. Versuche es später noch einmal.",
    unknown:
      "Ein unbekannter Fehler ist aufgetreten. Versuche es später noch einmal."
  },
  common: {
    buyCoins: "Coins Kaufen",
    profile: "Dein Profil"
  },
  nav: {},
  views: {
    landing: {
      title: "Das Portal um meine exklusiven Videos zu erleben.",
      text:
        "<p>Erhalte Zugriff auf alle meine Videos und exklusive Inhalte die du nur hier finden kannst.</p><p>Du hast meine Videos schon auf anderen Portalen gekauft? Registeriere dich bis zum 31.12. und übernehme deine bisherigen Käufe.</p>",
      signup: "Jetzt registrieren"
    },
    start: {
      newVideos: "Neue Videos",
      featured: "Featured",
      recommended: "Für dich empfohlen"
    },
    purchases: {
      title: "Deine gekauften Videos",
      empty:
        'Du hast noch keine Videos gekauft. Klicke <router-link to="/feed">hier</router-link> und wähle dein erstes Lady Janis Video. '
    },
    charge: {
      transfersOpen: "Jetzt überweisen!",
      transfersDisclaimer:
        "Die Coins werden dir 1-2 Tage nach Zahlungseingang gutgeschrieben.",
      transfersCancel: "Stornieren",
      coinsFree: "Coins geschenkt",
      pscDisclaimer:
        'Mit paysafecard kannst du komplett anonym zahlen – und das von überall auf der Welt! <a href="https://www.paysafecard.com/de-de/" target="_blank">Installiere dir am besten die paysafecard App auf deinem Handy und lade dein Guthaben in wenigen Minuten auf.</a> Alternativ kannst du paysafecards auch im Einzelhandel erwerben.'
    },
    settings: {
      title: "Dein Profil",
      changePassword: "Passwort ändern"
    },
    age: {
      title: "Bestätige jetzt deine Volljährigkeit!",
      subTitle:
        "Jugendschutz hat für mich höchste Priorität. Daher muss ich zuerst sicherstellen, dass du alt genug für meine Seite bist.",
      manual: "Manuelle Überprüfung (1-2 Tage)",
      manualDisclaimer:
        "Ich empfehle die Altersverifikation mit Sofort Ident. Solltest du jedoch eine manuelle Überprüfung bevorzugen, wende dich bitte an unseren Support unter support@ladyjanis.com.",
      sofort: "Online Überprüfung (sofort)",
      sofortDisclaimer:
        "Klicke hier, um die Online Verifizierung durch Sofort Ident zu starten.",
      sofortDisclaimer2:
        "Beachte bitte, dass du ein Deutsches Bankkonto mit Onlinebanking benötigst. Die Überprüfung ist selbstverständlich kostenlos und Datenschutzkonform.",
      sofortError:
        "Leider steht dir die Überprüfung via Sofort Ident nicht zu Verfügung. Wähle bitte die manuelle Altersverifikation."
    }
  }
} as LocaleMessageObject;
